import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";

import "../../styles/profile-pages.css";

export default function ProfilePageLayout({
  title,
  subtitle,
  icon: Icon,
  children,
}) {
  const navigate = useNavigate();

  return (
    <div className="profile-page-shell">

      <Navbar />

      {/* FONDO DECORATIVO */}
      <div className="profile-page-bg">
        <div className="profile-page-bg-grid"></div>
        <div className="profile-page-bg-glow profile-page-bg-glow-one"></div>
        <div className="profile-page-bg-glow profile-page-bg-glow-two"></div>
        <div className="profile-page-bg-city"></div>
      </div>

      <main className="profile-template-page">

        {/* HEADER */}
        <section className="profile-template-header">

          <button
            type="button"
            className="profile-template-back"
            onClick={() => navigate("/profile")}
          >
            <ArrowLeft size={20} />
            <span>Volver a mi perfil</span>
          </button>

          <div className="profile-template-heading">

            {Icon && (
              <div className="profile-template-icon">
                <Icon size={26} />
              </div>
            )}

            <div>
              <span>DEBUTS CROP</span>

              <h1>{title}</h1>

              {subtitle && (
                <p>{subtitle}</p>
              )}
            </div>

          </div>

        </section>

        {/* CONTENT */}
        <section className="profile-template-content">
          {children}
        </section>

      </main>

      <Footer />

    </div>
  );
}